export default {"src":"/_next/static/media/bike-icon.3f057155.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};